
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fashionunited-news",
      function () {
        return require("private-next-pages/fashionunited-news.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fashionunited-news"])
      });
    }
  